import React, { useEffect, useRef, useState } from "react";
import { HttpGet, HttpPost, HttpPostFile } from "../../providers/HttpClient";
import LoadingOverlay from "react-loading-overlay-ts";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Camera } from "react-camera-pro";
import { toast } from "react-toastify";
import spinner from "../../assets/svg/spinner.svg";
import Alert from "../alertComponent/alertComponent";
import camera from "../../assets/svg/camera.svg";
import add from "../../assets/svg/add.svg";
import remove from "../../assets/svg/remove.svg";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const PatrolComponent = () => {
  const navigate = useNavigate();
  // const camera = useRef(null);
  //   const [image,setImage] = useState(null);
  const locationId = useParams();
  const [open, setOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState(false);
  const [addImage, setAddImage] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [imageName1, setImageName1] = useState("");
  const [imageName2, setImageName2] = useState("");
  const [imageName3, setImageName3] = useState("");
  const [imageUrl1, setImageUrl1] = useState("");
  const [imageUrl2, setImageUrl2] = useState("");
  const [imageUrl3, setImageUrl3] = useState("");
  const inputRef = useRef<HTMLInputElement | null>(null);
  const inputRef2 = useRef<HTMLInputElement | null>(null);
  const inputRef3 = useRef<HTMLInputElement | null>(null);
  const noteRef = useRef<HTMLTextAreaElement>(null);
  const [loadingImage1, setLoadingImage1] = useState(false);
  const [loadingImage2, setLoadingImage2] = useState(false);
  const [loadingImage3, setLoadingImage3] = useState(false);
  const [photoTo, setPhotoTo] = useState("");

  const convertBase64ToFile = (base64String) => {
    const byteString = atob(base64String.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ia], { type: "image/png" }); // Buat Blob dari data mentah
    const file = new File([blob], "image.png", { type: "image/png" }); // Buat File dari Blob

    return file;
  };

  const alert = (message, type, subMessage) => {
    setOpen(true);
    setAlertMessage(message);
    setAlertType(type);
  };

  const handleClick = () => {
    inputRef?.current?.click();
    setPhotoTo("1");
  };

  const handleClick2 = () => {
    inputRef2?.current?.click();
    setPhotoTo("2");
  };

  const handleClick3 = () => {
    inputRef3?.current?.click();
    setPhotoTo("3");
  };

  const closeAction = async () => {
    setOpen(false);
    navigate("/home");
  };

  const uploadChoosenPhoto = async (event) => {
    let formData = new FormData();
    formData.append("image", event.target.files[0]);

    if (photoTo === "1") {
      setLoadingImage1(true);
    } else if (photoTo === "2") {
      setLoadingImage2(true);
    } else if (photoTo === "3") {
      setLoadingImage3(true);
    }
    HttpPostFile(`member/images?feature=patrol`, formData).then((res: any) => {
      if (photoTo === "1")
        return (
          setImageName1(res.data),
          setImageUrl1(res.data),
          setLoadingImage1(false)
        );
      if (photoTo === "2")
        return (
          setImageName2(res.data),
          setImageUrl2(res.data),
          setLoadingImage2(false)
        );
      if (photoTo === "3")
        return (
          setImageName3(res.data),
          setImageUrl3(res.data),
          setLoadingImage3(false)
        );
    });
  };

  const postData = () => {
    if (imageName1 == "") return toast.error("Foto Area 1 Harap Diisi");
    // if (imageName2 == "") return toast.error("Foto Area 2 Harap Diisi");
    // if (imageName3 == "") return toast.error("Foto Area 3 Harap Diisi");
    if (noteRef.current?.value == "")
      return toast.error("Keterangan Harap Diisi");
    let body = {
      areaOnePicture: imageName1,
      areaTwoPicture: imageName2,
      areaThreePicture: imageName3,
      idCheckPoint: locationId.id,
      note: noteRef.current.value,
    };

    HttpPost(`member/patrol`, body)
      .then((res: any) => {
        alert("Absensi Patroli Berhasil", true, "");
      })
      .catch((err) => {
        alert("Absensi Patroli Gagal", false, "");
        let counter: any = sessionStorage.getItem("scanCounter");
      });
  };

  useEffect(() => {
    // if (latitude && longitude) {
    //   getAddress(latitude, longitude);
    // }
  }, []);

  return (
    <div className="bg-main h-full mb-12">
      <Alert
        type={alertType}
        isOpen={open}
        closeAction={closeAction}
        message={alertMessage}
        subMessage={""}
      />
      <section id="main" className="px-8 pb-28 pt-8 z-50">
        <>
          <div className="z-100 z-30 mb-4">
            {/* <div>
              <div
                className="flex"
                onClick={() => handleClick()}
                // onClick={() => {
                //   setAddImage(!addImage);
                // }}
              >
                <img src={add} alt="add" className="w-8 h-8" />
                <p className="flex items-center z-10 top-2 right-5 text-sm">
                  {imageUrl1 !== "" ? "Ubah Foto" : "Tambah Foto"}
                </p>
              </div>
            </div> */}
            <div>
              <label htmlFor="overtime" className="block text-gray-700">
                Foto Area
              </label>
              <div hidden={loadingImage1 == false}>
                <Skeleton
                  containerClassName="border-2 border-gray-400 border-dashed flex justify-center relative bg-white rounded-2xl"
                  baseColor="#000000"
                  highlightColor="#363434"
                  className="w-full h-36 relative rounded-xl object-cover saturate-50 z-[1]"
                  style={{ borderRadius: 12 }}
                />
              </div>
              {loadingImage1 == false ? (
                <div
                  // hidden={loadingImage1 == true}
                  className="border-2 border-gray-400 border-dashed flex justify-center relative bg-white rounded-2xl"
                  onClick={() => handleClick()}
                >
                  <img
                    // hidden={loadingImage1 == true}
                    src={imageUrl1 ? `${imageName1}` : null}
                    className="w-full h-36 relative rounded-xl object-cover saturate-50 z-[1]"
                  />
                  <input
                    type="file"
                    ref={inputRef}
                    accept="image/*"
                    capture
                    style={{ display: "none" }}
                    id="photo"
                    name="photo"
                    // onChange={inputHandler}
                    onChangeCapture={(event) => uploadChoosenPhoto(event)}
                    placeholder="pilih foto"
                  />
                  <img
                    // hidden={loadingImage1 == true}
                    src={camera}
                    alt=""
                    className="absolute z-[2] top-14 w-10 h-10"
                  />
                </div>
              ) : null}
            </div>
            <div>
              <label htmlFor="overtime" className="block text-gray-700">
                Foto Area 2
              </label>
              <div hidden={loadingImage2 == false}>
                <Skeleton
                  containerClassName="border-2 border-gray-400 border-dashed flex justify-center relative bg-white rounded-2xl"
                  baseColor="#000000"
                  highlightColor="#363434"
                  className="w-full h-36 relative rounded-xl object-cover saturate-50 z-[1]"
                  style={{ borderRadius: 12 }}
                />
              </div>
              {loadingImage2 == false ? (
                <div
                  // hidden={loadingImage2 == true}
                  className="border-2 border-gray-400 border-dashed flex justify-center relative bg-white rounded-2xl"
                  onClick={() => handleClick2()}
                >
                  <img
                    // hidden={loadingImage2 == true}
                    src={imageUrl2 ? `${imageName2}` : null}
                    className="w-full h-36 relative rounded-xl object-cover saturate-50 z-[1] "
                  />
                  <input
                    type="file"
                    ref={inputRef2}
                    accept="image/*"
                    capture
                    style={{ display: "none" }}
                    id="photo"
                    name="photo"
                    // onChange={inputHandler}
                    onChangeCapture={(event) => uploadChoosenPhoto(event)}
                    placeholder="pilih foto"
                  />
                  <img
                    // hidden={loadingImage2 == true}
                    src={camera}
                    alt=""
                    className="absolute z-[2] top-14 w-10 h-10"
                  />
                </div>
              ) : null}
            </div>
            <div>
              <label htmlFor="overtime" className="block text-gray-700">
                Foto Area 3
              </label>
              <div hidden={loadingImage3 == false}>
                <Skeleton
                  containerClassName="border-2 border-gray-400 border-dashed flex justify-center relative bg-white rounded-2xl"
                  baseColor="#000000"
                  highlightColor="#363434"
                  className="w-full h-36 relative rounded-xl object-cover saturate-50 z-[1]"
                  style={{ borderRadius: 12 }}
                />
              </div>
              {loadingImage3 == false ? (
                <div
                  // hidden={loadingImage3 == true}
                  className="border-2 border-gray-400 border-dashed flex justify-center relative bg-white rounded-2xl"
                  onClick={() => handleClick3()}
                >
                  <img
                    // hidden={loadingImage3 == true}
                    src={imageUrl3 ? `${imageName3}` : null}
                    className="w-full h-36 relative rounded-xl object-cover saturate-50 z-[1]"
                  />
                  <input
                    type="file"
                    ref={inputRef3}
                    accept="image/*"
                    capture
                    style={{ display: "none" }}
                    id="photo"
                    name="photo"
                    // onChange={inputHandler}
                    onChangeCapture={(event) => uploadChoosenPhoto(event)}
                    placeholder="pilih foto"
                  />
                  <img
                    // hidden={loadingImage3 == true}
                    src={camera}
                    alt=""
                    className="absolute z-[2] top-14 w-10 h-10"
                  />
                </div>
              ) : null}
            </div>
            <div className="mb-4 mt-4">
              <label htmlFor="note" className="block text-gray-700">
                Keterangan
              </label>
              <textarea
                id="note"
                className="border border-gray-300 rounded-lg px-4 py-2 w-full"
                ref={noteRef}
              />
              {/* ) : null} */}
            </div>
          </div>
        </>
      </section>
      <div className="fixed bottom-0 w-full bg-white px-4 py-5 z-[9999]">
        <div
          onClick={() => postData()}
          className="text-center rounded-md bg-green-200 px-5 py-2 text-sm font-medium w-full"
        >
          Laporkan
        </div>
      </div>
    </div>
  );
};
export default PatrolComponent;
